import { Filters } from '../../../../constants/filter/filters';
import { FilterValues } from '../../../../constants/filter/filter_values';
import { getSpeedIndexAbsoluteValue } from '../../../../../_modules/tyre_index/get_speed_index_for_absolute_value';

function filterToCurrentSizes(filters, displayDimensions = '') {
    let sizes = filters[Filters.WIDTH] + '/' + filters[Filters.HEIGHT] + 'R' + filters[Filters.DIAMETER];
    if (FilterValues.NONE === filters[Filters.HEIGHT]) {
        sizes = filters[Filters.WIDTH] + 'R' + filters[Filters.DIAMETER];
    }

    if (displayDimensions.trim().length > 0) {
        sizes = displayDimensions;
    }

    if ( filters[Filters.SPEED_INDEX] || filters[Filters.LOAD_INDEX] ) {
        sizes += ' ';

        if (filters[Filters.LOAD_INDEX]) {
            sizes += filters[Filters.LOAD_INDEX];
        }

        if (filters[Filters.SPEED_INDEX]) {
            sizes += getSpeedIndexAbsoluteValue(filters[Filters.SPEED_INDEX]);
        }
    }

    return sizes;
}

export default filterToCurrentSizes;